import { Box, Skeleton } from "@outschool/backpack";
import { LeaderDetailsCardLoading } from "@outschool/ui-components-website";
import { Space } from "@outschool/ui-legacy-component-library";
import * as React from "react";

import { TileInfoBoxLoading } from "../components/TileInfoBox";

const CARD_MARGIN_RIGHT = 18;

export const ListingCardLoading = ({
  columnWidth = 242,
  isTutoringCLP,
}: {
  columnWidth?: number;
  isTutoringCLP: boolean;
}) => {
  return isTutoringCLP ? (
    <Box
      sx={{
        width: 550,
        backgroundColor: "#FFF",
        border: "1px solid #DDDFE3",
        borderRadius: 8,
        padding: 16,
      }}
    >
      <Box flex sx={{ flexDirection: "row", gap: "1em" }}>
        <Skeleton
          sx={{ borderRadius: 8 }}
          variant="rounded"
          width={243}
          height={243}
        />
        <Box flex sx={{ flexDirection: "column", gap: "0.5em" }}>
          <Skeleton variant="rectangular" width={243} height={80} />
          <Skeleton variant="rectangular" width={50} height={20} />
          <Skeleton variant="rectangular" width={243} height={20} />
          <Skeleton variant="rectangular" width={243} height={20} />
          <Skeleton variant="rectangular" width={243} height={20} />
          <Skeleton variant="rectangular" width={243} height={20} />
          <Skeleton
            sx={{ borderRadius: 100 }}
            variant="rounded"
            width={120}
            height={20}
          />
        </Box>
      </Box>
      <Box sx={{ paddingTop: "1em" }}>
        <Skeleton variant="rectangular" width={"100%"} height={100} />
      </Box>
    </Box>
  ) : (
    <Box
      sx={{
        width: columnWidth,
        backgroundColor: "#FFF",
        border: "1px solid #DDDFE3",
        borderRadius: 8,
        marginRight: CARD_MARGIN_RIGHT,
      }}
    >
      <Skeleton variant="rectangular" height={125} />
      <Box sx={{ padding: 16 }}>
        <Box>
          <Box flex>
            <Skeleton variant="text" width={85} height={24} />
            <Box sx={{ width: "45%" }} />
            <Skeleton
              sx={{ float: "right" }}
              variant="rectangular"
              width={30}
              height={30}
            />
          </Box>

          <Skeleton variant="text" height={102} />
        </Box>
        <Space y="xsmall" />
        <LeaderDetailsCardLoading />
        <Space y="medium" />
        <Box flex>
          <TileInfoBoxLoading />
          <TileInfoBoxLoading />
          <TileInfoBoxLoading />
        </Box>
      </Box>
    </Box>
  );
};
